





































import { Component, Mixins, Inject, Prop } from "vue-property-decorator";
import LoggedUserMixin from "@/mixins/loggedUserMixin";
import {
  INote,
  INotesProviderData,
  INotesProviderMethods
} from "@/models/notes";
import { IUser } from "@/models/users";

@Component({
  components: {
    note: () => import("@/components/app/admin/notes/note.vue")
  }
})
export default class Notes extends Mixins(LoggedUserMixin) {
  // Inject

  @Inject({ from: "notesProviderData" })
  public readonly notesData!: () => INotesProviderData;

  @Inject({ from: "notesProviderMethods" })
  public readonly $notesMethods!: INotesProviderMethods;

  // Props

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  // Computed

  public get $notesData() {
    return this.notesData();
  }

  // Methods

  public canCollaborate(note: INote & { user: IUser }): boolean {
    if (this.isDisabled) return false;
    return this.loggedUser.admin || note.user.id === this.loggedUser.id;
  }

  public onEdit(note: INote & { user: IUser }) {
    if (!this.$notesData.canEdit || !this.canCollaborate(note)) return;
    return () => this.$notesMethods.editNote(note);
  }

  public onPin(note: INote & { user: IUser }) {
    if (!this.$notesData.canEdit || !this.canCollaborate(note)) return;
    return () => this.$notesMethods.pinNote(note);
  }

  public onDelete(note: INote & { user: IUser }) {
    if (!this.$notesData.canDelete || !this.canCollaborate(note)) return;
    return () => this.$notesMethods.deleteNote(note);
  }
}
